import { Auth0Provider } from "@auth0/auth0-react";
import { PropsWithChildren } from "react";
import { clearStaleLegacyCookies } from "./clearStaleLegacyCookies";

// One-shot migration: remove the stale auth_type / id_token cookies left
// behind by pre-DSP-1477 sessions. Runs at module load (not inside the
// component) so it executes exactly once per page, before any auth context
// renders. Slated for removal one release after the rollout — DSP-1825:
// https://remerge.atlassian.net/browse/DSP-1825
clearStaleLegacyCookies();

type SharedAuth0ProviderProps = PropsWithChildren<{
  onRedirectCallback?: (appState?: { returnTo?: string }) => void;
}>;

/** Shared Auth0 provider wrapper with repo-standard env wiring. */
export default function SharedAuth0Provider({ children, onRedirectCallback }: SharedAuth0ProviderProps) {
  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN as string}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID as string}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens
      authorizationParams={{
        redirect_uri: import.meta.env.VITE_AUTH0_REDIRECT_URI as string,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE as string,
      }}
    >
      {children}
    </Auth0Provider>
  );
}
